import React from 'react';
import CompanyIcon from 'assets/img/logo/Hyvid_Icon.png';
import CompanyNameImage from 'assets/img/logo/HyvidOne_Logo.png';
// import { ReactComponent as CompanyLogo } from 'assets/svg/intsamis_logo.svg';
// import CompanyNameImage from 'assets/img/logo/intsamis_logo_dark.png';

const ApplicationName = ({logoOnly, extra, logoClass, companyNameClass, ...props}) => {

  	return (    
	    <div className={`${extra}`}>
		    <div className={`p-2 ${logoOnly ? '': 'hidden'}`}>
				<img src={CompanyIcon} alt="Hyvid Icon" style={{'maxHeight':'34px'}}/>
			</div>
			<div className={`p-2 company-name ${logoOnly ? 'hidden': ''} ${companyNameClass}`}>
				<img src={CompanyNameImage} alt="HyvidOne"/>
			</div>
	  	</div>
  	);
};

export default ApplicationName;